import React from "react";
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import dpclaimstab from '../assets/claims_header_tab.png';
import Hidden from '@material-ui/core/Hidden';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ls from 'local-storage'
import forge from 'node-forge';
import Link from '@material-ui/core/Link';

import InfoIcon from '@material-ui/icons/Info';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import TermsDialog from './admin/terms';

const styles = theme => ({

  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  wrappingA:{
      marginTop:"10vh",
  },
});

class HomePage extends React.Component {

  state = {
    value: 0,
    credentials:[],
    offline:false,
    showTerms: false,
    loginResult: {},
  };

    constructor(props){
        super(props);
        this.props=props;
        this._didCreate=true;
        
    }

    termsClose = () => {
        this.setState({showTerms: false});
    }

    validLogin = async () => {
        //console.log({login_result: this.state.loginResult});
        if (this.state.loginResult.authenticator) {
            this.props.parent.setState({authenticator:this.state.loginResult.authenticator});
            this.props.parent.setState({authenticated:this.state.loginResult.value});
            this.props.parent.setState({initials:this.state.loginResult.initials});
            ls.set("initials",this.state.loginResult.initials);
            ls.set("authenticator",this.state.loginResult.authenticator);
            ls.set("username", this.state.loginResult.username);
            ls.set("practice", this.state.loginResult.practice);
        }

        this.setState({loginResult: {}});
    }

    closeSnack = (event,reason)=>{
        if (reason === 'clickaway') {
            return;
        }

        this.setState({ snackopen: false });
    } 

    componentDidMount = (d)=>{
        this.props.socket.on("login_response",async (d)=>{
            if(this._didCreate){
                if(d.value){
                    if(d.authenticator){
                        //console.log({login_response: d});

                        if (!this.state.loginResult.authenticator) {

                            await this.setState({loginResult: d});

                            if (d.termsagreed === 'n')
                                await this.setState({showTerms: true});
                            else {
                                await this.validLogin();
                            }
                        }
                    }
                }else{
                    this.setState({errorText:"Username or password was incorrect"});
                }
            }
        });        
        this.props.socket.on("connect",d=>{
            this.setState({offline:this.props.socket.disconnected});
        });
        this.props.socket.on("connect_error",d=>{
            this.setState({offline:this.props.socket.disconnected});
        });
        if(ls.get("resetpassword")){
            this.snackbarText="We have sent you a password reset email. Please check your inbox.";
            this.setState({ snackopen: true });
            ls.remove("resetpassword");
        }
        if(ls.get("resetfinished")){
            this.snackbarText="Your password has now been reset and you can log in with the new password.";
            this.setState({ snackopen: true });
            ls.remove("resetfinished");
        }

    };
    handleTextChange = name => event => {
        let copyCreds = this.state.credentials;
        copyCreds[name]=event.target.value;
        this.setState({credentials:copyCreds });
    };

    loginButtonClick = (e) =>{
        //this.props.parent.setState({authenticated:true});
        //console.log(this.state);
        
        if(this.state.credentials['password']){
            let username=this.state.credentials['username'];
            let password = this.state.credentials['password'];

            var md = forge.md.sha256.create();
            md.update(password);
            var hashpassword = md.digest().toHex();

            //console.log('here');
            this.props.socket.emit("login_attempt",{username:username,password:hashpassword});
        }else{
            this.setState({errorText:"Username or password was incorrect"});
        }
    }

    loginKeyPress= (e)=>{
        if(e.key === "Enter"){
            if(this.state.credentials['password']){
                let username=this.state.credentials['username'];
                let password = this.state.credentials['password'];

                var md = forge.md.sha256.create();
                md.update(password);
                var hashpassword = md.digest().toHex();

                this.props.socket.emit("login_attempt",{username:username,password:hashpassword});
            }else{
                this.setState({errorText:"Username or password was incorrect"});
            }
        }
    }

    render(){
        const { classes } = this.props;
    return (
        <>
            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={this.state.snackopen}
                autoHideDuration={6000}
                onClose={this.closeSnack}
                ContentProps={{
                    'aria-describedby': 'message-id',
                }}
                message={<span id="message-id"><InfoIcon/> {this.snackbarText}</span>}
                action={[
                    
                    <IconButton
                    key="close"
                    aria-label="Close"
                    color="inherit"
                    className={classes.close}
                    onClick={this.closeSnack}
                    >
                    <CloseIcon />
                    </IconButton>,
                ]}
            />

        <img src={dpclaimstab} alt="DentalPlus Claims" style={{display:"block",marginTop:"0 !important",marginLeft:"auto",marginRight:"auto"}}></img>
        <div style={{color:"#0072BC"}}>
            <TermsDialog socket={this.props.socket} authenticator={this.state.authenticator} 
                show={this.state.showTerms} loginAction={this.validLogin}
                closeAction={this.termsClose} />
            
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                className={classes.wrappingA}
            >
                <Hidden only={['xs','sm','md','lg','xl']}>
                <Grid item xs={12} sm={6} style={{ borderRight: '0.1em solid #0072BC', }}>
                    <div style={{paddingLeft:"5vw"}}>
                    <h1 style={{marginTop:"5vh"}}>Welcome to DentalPlus Claims</h1>
                    <h2 style={{marginTop:"5vh",marginLeft:"2.5vw"}}>DentalPlus Claims makes things quick and easy</h2>
                    <ul style={{marginLeft:"2.5vw",color:"#000"}}>
                        <li>Manage and search your patient records</li>
                        <li>Send NHS claims electronically</li>
                        <li>See UDA insights and feedback</li>
                        <li>Something else also on this list</li>
                    </ul>
                    <Button variant="outlined" className={classes.button} style={{width:"25vw",marginLeft:"2.5vw",marginBottom:"10vh"}}>
                        Get started for free
                    </Button>
                    </div>
                </Grid>
                </Hidden>
                <Grid item xs={12} sm={12} style={{textAlign:"center"}}>
                    
                    {this.state.offline ?
                        <>
                            <div style={{width:"50vw",marginLeft:"auto",marginRight:"auto"}}>
                            <Paper className={classes.root} elevation={4} style={{padding:"1vw",backgroundColor:"#ff3355"}}>
                                <Typography variant="h5" component="h3" style={{color:"#ffffff"}}>
                                    Maintenance
                                </Typography>
                                <Typography component="p" style={{color:"#fff"}}>
                                    The system is down for temporary maintenance - we'll be back very soon. <br></br>The log in screen will appear automatically when we are back.
                                </Typography>
                            </Paper>
                            </div>
                        </>
                    :
                    <>
                    <div style={{paddingLeft:"5vw"}}>
                    <h1 style={{marginTop:"3vh"}}>Log In</h1>
                    <label style={{display:"block",color:"red"}}>{this.state.errorText}</label>
                    <TextField
                        id="username"
                        style={{width:"50vw"}}
                        label="User Name"
                        placeholder="user@practice"
                        onChange={this.handleTextChange("username")}
                        className={classes.textField}
                        defaultValue={this.state.username}
                        onKeyPress={this.loginKeyPress}
                        //onChange={this.handleChange('name')}
                        margin="normal"
                    /><br></br>
                    <TextField
                        id="password"
                        onKeyPress={this.loginKeyPress}
                        defaultValue={this.state.password}
                        onChange={this.handleTextChange("password")}
                        label="Password"
                        type="password"
                        autoComplete="current-password"
                        className={classes.textField}
                        //onChange={this.handleChange('name')}
                        margin="normal"
                        style={{marginBottom:"5vh",width:"50vw"}}
                    />
                    
                    <br/>
                    <Button variant="outlined" onClick={this.loginButtonClick} className={classes.button}>
                        Log in
                    </Button>
                    <br/><br/>
                    <Link style={{cursor:"pointer"}} onClick={()=>{this.props.history.push("/forgotpassword");}}>I have forgotten my password</Link>
                    
                    <div style={{fontSize:"9px", position:"fixed", bottom: "0px"}}>Build: 31st July 2023</div>
                    
                    </div>
                    </>
                    }
                    
                </Grid>
            </Grid>
            
    </div>
    </>
    );
    }

}

export default withStyles(styles)(HomePage);